import { HttpClientModule } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { ButtonsModule } from '@progress/kendo-angular-buttons';
import { IconsModule } from '@progress/kendo-angular-icons';
import { LoaderModule } from '@progress/kendo-angular-indicators';
import { TooltipsModule } from '@progress/kendo-angular-tooltip';
import { SharedUIModule } from '@shared/ui';
import {
  ProfileComponent,
  RecommendationComponent,
  RecommendationPanelComponent,
  RecommendationsComponent,
  SubjectSelectorComponent,
} from './components';

const COMPONENTS = [
  ProfileComponent,
  RecommendationComponent,
  RecommendationPanelComponent,
  RecommendationsComponent,
  SubjectSelectorComponent,
];

@NgModule({
  imports: [
    ButtonsModule,
    HttpClientModule,
    IconsModule,
    LoaderModule,
    SharedUIModule,
    TooltipsModule,
  ],
  declarations: [...COMPONENTS],
  exports: [...COMPONENTS],
})
export class StudentModule {}
